export const APP_NAME = "Offerings";
export const APP_TAG_LINE = "Donations made easy";

// export const API_BASE_URL = "http://localhost:8080";
export const API_BASE_URL = "https://offerings-app-54793841534.us-central1.run.app";
export const WEB_BASE_URL = "https://offerings.milesoft.app";

export const PATH_DEEP_LINK = "/deep-link";

export const CLOUDINARY_ID = "cuteandfuzzy";

export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyA9Dj9SL_KXAQw4DfB-66XmJvyAUytOMdo",
    authDomain: "cf-notifier.firebaseapp.com",
    projectId: "cf-notifier",
    storageBucket: "cf-notifier.appspot.com",
    messagingSenderId: "741330969895",
    appId: "1:741330969895:web:795f316c4aca845967f502",
    measurementId: "G-7YK8FMDCTM"
};

export const NAMESPACE = "offerings";
export const KEY_VERSION = "version";

export const LABEL_ANY = "-any-";
export const LABEL_NONE = "-none-";

export const EDGE_CATEGORY = "household";
export const EDGE_LABEL = "member";

export const ID_ANONYMOUS = "anonymous";
export const ANONYMOUS = "Anonymous";

export const NODE_ANONYMOUS = {
    id: ID_ANONYMOUS,
    firstName: ANONYMOUS,
};

export const DATE_HIDDEN = "Hidden";
export const DATE_ONCE = "Once";
export const DATE_YEARLY = "Yearly";

export const DATE_MODES = {
    [DATE_YEARLY] : "Show every year (e.g. birthday)",
    [DATE_ONCE] : "Show on exact date (e.g. baptism)",
    [DATE_HIDDEN] : "Do not show on calendar",
};

// node dates
export const COLORS = [
    "#FF0000",
    "#008000",
    "#0000FF",
    "#FFFF00",
    "#00FFFF",
    "#FF00FF",
    "#FFA500",
    "#800080",
    "#32CD32",
    "#008080",
    "#FFC0CB",
    "#A52A2A",
];

// custom events added just to calendar
export const COLOR = "#424242";

export const TASK_TYPE = "event";

export const DEACON = "ROLE_DEACON";
export const SECRETARY = "ROLE_SECRETARY";

export const TYPE_ADMIN = "Admin";
export const TYPE_DEACON = "Deacon";
export const TYPE_SECRETARY = "Secretary";

export const TYPES = [
    TYPE_ADMIN,
    TYPE_DEACON,
    TYPE_SECRETARY,
];

export const CSV_DELIMITER = ",";

export const CSV_FILENAME_OFFERINGS = "offerings.csv";
export const CSV_FILENAME_NODES = "members.csv";

export const CSV_FIELD_DATE = "date";
export const CSV_FIELD_CATEGORY = "category";
export const CSV_FIELD_TYPE = "type";
export const CSV_FIELD_AMOUNT = "amount";
export const CSV_FIELD_MEMBER = "member";

export const CSV_FIELD_FIRST_NAME = "firstName";
export const CSV_FIELD_LAST_NAME = "lastName";
export const CSV_FIELD_EMAIL = "email";
export const CSV_FIELD_PHONE = "phone";
export const CSV_FIELD_CREATED = "created";
export const CSV_FIELD_UPDATED = "updated";

export const CSV_HEADERS_OFFERINGS = [
    {
        key: CSV_FIELD_DATE,
        label: "Date",
    },
    {
        key: CSV_FIELD_CATEGORY,
        label: "Category",
    },
    {
        key: CSV_FIELD_TYPE,
        label: "Type",
    },
    {
        key: CSV_FIELD_AMOUNT,
        label: "Amount",
    },
    {
        key: CSV_FIELD_MEMBER,
        label: "Member",
    },
];

export const CSV_HEADERS_NODES = [
    {
        key: CSV_FIELD_FIRST_NAME,
        label: "First Name",
    },
    {
        key: CSV_FIELD_LAST_NAME,
        label: "Last Name",
    },
    {
        key: CSV_FIELD_EMAIL,
        label: "Email",
    },
    {
        key: CSV_FIELD_PHONE,
        label: "Phone",
    },
    {
        key: CSV_FIELD_CREATED,
        label: "Created",
    },
    {
        key: CSV_FIELD_UPDATED,
        label: "Updated",
    },
];

export const PAGE_LOGIN = "/login";
export const PAGE_RECOVERY = "/recovery";
export const PAGE_WELCOME = "/welcome";
export const PAGE_NEW_USER = "/newUser";

export const PAGE_CALENDAR = "/calendar";
export const PAGE_OFFERINGS = "/offerings";
export const PAGE_NODES = "/members";
export const PAGE_NODE = "/member";

export const PAGE_ACCOUNT = "/account";
export const PAGE_USERS = "/users";
export const PAGE_USER = "/user";

export const PAGE_SETTINGS = "/settings";
export const PAGE_PASSWORD = "/password";
export const PAGE_JOIN_ACCOUNT = "/joinAccount";

export const PAGE_ABOUT = "/about";

export const PAGE_HOME = PAGE_NODES;

export const PAGES_MAIN = [
    PAGE_CALENDAR,
    PAGE_NODES,
    PAGE_OFFERINGS,
];

export const PAGES_MORE = [
    PAGE_ACCOUNT,
    PAGE_USERS,
    PAGE_SETTINGS,
    PAGE_PASSWORD,
    PAGE_JOIN_ACCOUNT,
    PAGE_ABOUT,
];

export const PRIVATE_PAGES_EXACT = [].concat(PAGES_MAIN).concat(PAGES_MORE);

export const PRIVATE_PAGES_STARTS_WITH = [
    PAGE_USER,
    PAGE_NODE,
];

export const PUBLIC_PAGES_EXACT = [
    PAGE_LOGIN,
    PAGE_RECOVERY,
];

export const PUBLIC_PAGES_STARTS_WITH = [];
